<template>
  <div v-show="states.is_open" class="tw-fixed tw-left-0 tw-top-0 tw-w-full tw-h-full tw-bg-dark tw-bg-opacity-70 tw-overflow-auto tw-z-50" v-on:click.prevent="store.close()">
    <div class="tw-mx-6">
      <div class="tw-relative tw-max-w-full md:tw-max-w-6xl tw-mx-auto tw-rounded tw-shadow-xl tw-my-16 tw-overflow-hidden" style="background: #fcfcfc" v-on:click.stop>
        <submit-task-confirm-close></submit-task-confirm-close>
        <div class="tw-bg-gradient-to-r tw-from-primary tw-to-secondary tw-text-white tw-py-6 tw-px-6 tw-flex tw-items-center tw-justify-between tw-relative">
          <div class="tw-text-3xl tw-font-bold tw-relative tw-py-1 tw-rounded">
            <span class="tw-font-bold">Get Quotes</span>
            <span class="tw-font-bold"> ({{states.step + 1}} / {{_.values(store.steps).length}})</span>
          </div>
          <button v-on:click.prevent="store.close()" class="tw-w-10 tw-h-10 tw-rounded-full tw-flex tw-items-center tw-justify-center hover:tw-bg-red hover:tw-text-light">
            <i class="bx bx-x tw-text-4xl"></i>
          </button>
        </div>
        <!--
        <div class="tw-bg-gradient-to-r tw-from-primary tw-to-secondary tw-p-6 tw-flex tw-items-center tw-justify-between tw-text-light">
          <div class="tw-font-semibold tw-text-2xl">{{store.componentTitle()}}</div>
          <div class="tw-font-bold">Step {{states.step + 1}} / {{_.values(store.steps).length}}</div>
        </div>
        -->
        <div style="height : 40rem" class="tw-overflow-auto">
          <component :is="store.component()"/>
        </div>
        <div v-show="!store.isLastStep()" class="tw-p-4 tw-text-3xl tw-font-bold tw-flex tw-items-center tw-justify-between tw-space-x-4">
          <div class="tw-flex tw-items-center tw-space-x-4 tw-flex-1">
            <button v-on:click="store.prev()" class="tw-flex-1 tw-rounded hover:tw-bg-light-4 tw-font-bold tw-text-light-11 hover:tw-text-blue tw-px-8 tw-py-4 tw-text-2xl">Back</button>
            <button v-on:click="store.next()" class="tw-flex-1 tw-rounded tw-bg-secondary cursor:tw-bg-secondary-cursor tw-bg-opacity-90 hover:tw-bg-opacity-100 tw-font-bold tw-text-light tw-px-8 tw-py-4 tw-text-2xl">
              {{store.isLastStep() === false ? 'Next' : (states.task === null ? 'Submit' : 'Update')}}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import store from './submit-task-store'
  import SubmitTaskConfirmClose from './submit-task-confirm-close'

  export default {
    components: {
      SubmitTaskConfirmClose,
    },
    props: {
      user: {},
      executionTimes: {},
      budgets: {},
      task: {
        default: null,
      },
    },
    beforeCreate() {
      this.store = store

      let openCallback = (event) => {
        store.open(event.detail)
      }
      document.addEventListener('open-get-quote', openCallback)
      this.$on('hook:beforeDestroy', () => document.removeEventListener('open-get-quote', openCallback))

      let openWithDefaultsCallback = (event) => {
        store.openWithDefaults(event.detail)
      }
      document.addEventListener('open-get-quote-with-defaults', openWithDefaultsCallback)
      this.$on('hook:beforeDestroy', () => document.removeEventListener('open-get-quote-with-defaults', openWithDefaultsCallback))
    },
    created() {
      store.hydrateTask(this.task)
      store.hydrateUser(this.user)
      store.hydrateBaseData({
        executionTimes: this.executionTimes,
        budgets: this.budgets
      })
      //  _.only(this,'categories','suburbs','executionTimes','budgets')

      this.$watch(() => store.states.is_open, value => {
        if (value === true) {
          document.body.classList.add('tw-overflow-hidden')
        } else {
          document.body.classList.remove('tw-overflow-hidden')
        }
      })
    },
    data: v => ({
      states: store.states
    })
  }
</script>
